import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from '@mui/material';
import {forwardRef, useImperativeHandle, useState} from 'react';
import {useForm} from 'react-hook-form';
import {toast} from 'react-toastify';
import {ServiceRequestService} from '../../../../../api/services/serviceRequest.service';
import {useEventBus} from '../../../../../hooks/useEventBus';
import {IServiceRequest} from '../../../../../shared/types/serviceRequest.types';
import {EMPTY_SERVICE_REQUEST, serviceRequestsQueryTrigger} from '../../../../../store/service-requests/atoms';
import {DadataAddressField} from '../../../../DaData';
import {getServiceRequestDto} from '../../../new/utils';
import {get, set} from 'lodash';
import {useSetRecoilState} from 'recoil';

interface Props {
  serviceRequest?: IServiceRequest;
}

export interface EditAddressFormModalHandlers {
  handleClickOpen: () => void;
}

function prepareDefaultValues(serviceRequest?: IServiceRequest) {
  const result = {...EMPTY_SERVICE_REQUEST};
  set(result, 'address.fullAddress', get(serviceRequest, 'address.fullAddress', null));
  return result;
}

export const EditAddressFormModal = forwardRef<EditAddressFormModalHandlers, Props>(({serviceRequest}, ref) => {
  const [open, setOpen] = useState(false);
  const bus = useEventBus();
  const defaultValues = prepareDefaultValues(serviceRequest);
  const triggerSRQuery = useSetRecoilState(serviceRequestsQueryTrigger);

  const {control, handleSubmit, reset} = useForm({
    defaultValues,
  });

  useImperativeHandle(ref, () => ({
    handleClickOpen: () => setOpen(true),
  }));

  const handleClose = () => {
    setOpen(false);
    reset(defaultValues);
  };

  const handleSave = handleSubmit(async (data) => {
    try {
      await ServiceRequestService.update(getServiceRequestDto({...serviceRequest, address: data.address}));

      toast.success('Адрес успешно обновлен', {
        containerId: 'default',
        autoClose: 2000,
        hideProgressBar: true,
        pauseOnHover: false,
        draggable: false,
      });
      setTimeout(() => triggerSRQuery((v) => v + 1), 1000);
    } catch (e) {
      bus?.emit('error', [e]);
    } finally {
      handleClose();
    }
  });

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Адрес</DialogTitle>
      <DialogContent>
        <Stack mt={2}>
          <DadataAddressField control={control} name="address.fullAddress" />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Отмена</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
});
